import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";
import { EmailTemplateContext, TEmailTemplateContextCodec } from "../EmailTemplateContext";

export const EmailTemplateContextForm: TFormCodec<
    TRequiredCodec<{
        case_id: TAnyStringCodec,
    }>,
    TEmailTemplateContextCodec
> = form(
    required({
        case_id: string(),
    }),
    EmailTemplateContext,
);
export type TEmailTemplateContextFormCodec = typeof EmailTemplateContextForm;
export type TEmailTemplateContextForm = TTypeOfCodec<TEmailTemplateContextFormCodec>;
